export default __webpack_public_path__ + "static/media/instagram.487f05c6.svg";